// Banner shown on the admin page when requests are waiting under OTHER years
// than the one selected — one click widens the filter to every year.
import React from 'react';
import { AlertTriangle } from 'lucide-react';

interface PendingOtherYearsBannerProps {
  count: number;
  onShowAllYears: () => void;
}

export const PendingOtherYearsBanner: React.FC<PendingOtherYearsBannerProps> = ({ count, onShowAllYears }) => {
  if (count <= 0) return null;
  return (
    <div className="mb-4 flex flex-wrap items-center justify-between gap-3 px-4 py-3 rounded-xl border border-amber-200 bg-amber-50 text-amber-900">
      <div className="flex items-center gap-2 text-sm">
        <AlertTriangle className="w-4 h-4 text-amber-600 shrink-0" />
        <span>
          <strong>{count}</strong> demande{count > 1 ? 's' : ''} en attente sur des années précédentes
        </span>
      </div>
      <button
        type="button"
        onClick={onShowAllYears}
        className="px-3 py-1.5 text-sm font-medium rounded-lg bg-amber-600 text-white hover:bg-amber-700 transition"
      >
        Voir toutes les années
      </button>
    </div>
  );
};

export default PendingOtherYearsBanner;
